
  import "@/components/app/scss/home/Home.scss"
  import { useStore } from "vuex"
  import { defineComponent, ref } from "vue"

  export default defineComponent({
    name: "AuthSection",
    props: {
      isLogin: Boolean,
      errorsList: Array,
    },
    setup(props) {
      const store = useStore()
      const formData = ref({ email: "", password: "", login: "" })
      // let isPassword = reactive(false)

      const sendData = () => {
        if (!props.isLogin) store.dispatch("registration", formData.value)
        else store.dispatch("login", formData.value)
      }

      return { sendData, formData }
    },
  })
